import script from "./BoardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BoardCard.vue?vue&type=script&setup=true&lang=js"

import "./BoardCard.vue?vue&type=style&index=0&id=3d54fca4&lang=css"

const __exports__ = script;

export default __exports__